module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-mobile@2x-2cb3f3b0d684128930b7aaee7da449cb.webp";